import script from "./AsideServer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AsideServer.vue?vue&type=script&lang=ts&setup=true"

import "./AsideServer.vue?vue&type=style&index=0&id=b015f742&lang=scss"

const __exports__ = script;

export default __exports__